import React from "react";

import { Router } from "@reach/router";
import registrationReducer from '../reducers/registrationReducer';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import SignUpController from '../viewControllers/SignUpController';
import SignUpCompleteController from '../viewControllers/SignUpCompleteController';
import Register from '../address/Register';
import SignUp from "./SignUp";
import PhoneNumber from "./PhoneNumber";
import UpLoadID from "./UpLoadID";
// TODO: This is the PreRegister location search, remove after launch
import FramableLocationSearch from '../preRegister/FramableLocationSearch';
import SignUpWithAddress from '../preRegister/SignUpWithAddress';

const registrationStore = createStore(registrationReducer);

const SignUpRoutes = () => {
  return (
    <Provider store={registrationStore}> 
      <Router>
        <Register path="address" />
        <SignUp path="signUp" />
        <PhoneNumber path="phoneNumber" />
        <UpLoadID path="uploadID" />
        <SignUpCompleteController path="registrationComplete" />
        <SignUpController default />
        <FramableLocationSearch path="framableLocationSearch" />
        <SignUpWithAddress path="signUpWithAddress" />
      </Router>  
    </Provider>
  ); 
}

export default SignUpRoutes;